import { constants } from "src/constant/constants";
import { getRequest, postRequest } from "../helper";

export const getAdminHorseList = async (filterParams) => {
  try {
    const res = await getRequest(constants.endPoints.adminEndPoints.horseList, filterParams)
    return res.data
  } catch (e) {
    throw e
  }
}

export const getAdminPendingHorseList = async (filterParams) => {
  try {
    const res = await getRequest(constants.endPoints.adminEndPoints.horseListPending, filterParams)
    return res.data
  } catch (e) {
    throw e
  }
}

export const getOwnerCreatedHorseList = async (filterParams) => {
  try {
    const res = await getRequest(constants.endPoints.ownerEndPoints.horseOwnerCreated, filterParams)
    return res.data
  } catch (e) {
    throw e
  }
}

export const getOwnerHorseList = async (filterParams) => {
  try {
    const res = await getRequest(constants.endPoints.ownerEndPoints.horseList, filterParams)
    return res.data
  } catch (e) {
    throw e
  }
}

export const getOwnerSearchHorse = async (filterParams) => {
  try {
    const res = await getRequest(constants.endPoints.ownerEndPoints.searchHorse, filterParams)
    return res.data
  } catch (e) {
    throw e
  }
}

export const adminCreateHorse = async (payload) => {
  try {
    const res = await postRequest(
      constants.endPoints.adminEndPoints.adminCreateHorse,
      payload
    );
    return res.data;
  } catch (e) {
    throw e;
  }
};


export const ownerCreateHorse = async (payload) => {
  const formData = new FormData();
  formData.append("memberID", payload.memberId);
  formData.append("name", payload.name);
  formData.append("registrationNum", payload.registrationNum);
  formData.append("sex", payload.sex);
  formData.append("color", payload.color);
  formData.append("bredBy", payload.bredBy);
  formData.append("DNA", payload.DNA);
  formData.append("DNA_CASE", payload.DNA_CASE);
  formData.append("DNA_TEST_DATE", payload.DNA_TEST_DATE);
  formData.append("sire", payload.sire);
  formData.append("sireRegNum", payload.sireRegNum);
  formData.append("dam", payload.dam);
  formData.append("damRegNum", payload.damRegNum);
  formData.append("grandSire", payload.grandSire);
  formData.append("grandSireRegNum", payload.grandSireRegNum);
  formData.append("grandDam", payload.grandDam);
  formData.append("grandDamRegNum", payload.grandDamRegNum);
  formData.append("greatGrandSire", payload.greatGrandSire);
  formData.append("greatGrandSireRegNum", payload.greatGrandSireRegNum);
  formData.append("greatGrandDam", payload.greatGrandDam);
  formData.append("greatGrandDamRegNum", payload.greatGrandDamRegNum);
  formData.append("foalDate", payload.foalDate);
  formData.append("breedingDate", payload.breedingDate);
  formData.append("markings", payload.markings);
  formData.append("pedigree", payload.pedigree);
  formData.append("verified", payload.verified);
  formData.append("dnaKitDocument", payload.dnaKitDocument);
  formData.append("registrationDocument", payload.registrationDocument);

  try {
    const res = await postRequest(
      constants.endPoints.ownerEndPoints.ownerCreateHorse,
      formData
    );
    return res.data;
  } catch (e) {
    throw e;
  }
};
